import { Controller } from "@hotwired/stimulus"

// Un invio alla volta (disabled={running} dell'originale): finché la risposta non arriva, un altro invio del form è
// ignorato (Turbo disabilita il pulsante solo dopo l'avvio della richiesta).
// <form data-controller="invio-unico" data-action="submit->invio-unico#invia turbo:submit-end->invio-unico#fine">
export default class extends Controller {
  invia(event) {
    if (this.inCorso) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
    this.inCorso = true
  }

  fine() { this.inCorso = false }
}
